import Checkbox from '@mui/material/Checkbox'
import './CheckBox.scss'
import { useTheme } from '@mui/material'

type Props = any
const defaultClassName = 'checkbox-custom-element'

const CheckboxElement = (props: Props) => {
    const theme = useTheme()
    const { sx, ...rest } = props
    const combineClassName = `${props?.className ?? ''} ${defaultClassName}`
    console.log('ha_check_combineClassName', combineClassName);
    const combineStyle = { color: theme.palette.primary.main, ...props?.sx }

    return (
        <Checkbox  {...rest} sx={combineStyle} className={combineClassName} />
    )
}

export default CheckboxElement
